import React from 'react';
import { FormattedMessage } from 'react-intl';

export default (bankName, acctString) => ({
  account_needed: {
    icon: 'bank-orange',
    header: (<FormattedMessage id="hosting.bank_status_data.account_needed_header" defaultMessage="Add a bank"/>),
    body: (<FormattedMessage id="hosting.bank_status_data.account_needed_body" defaultMessage="Add a bank account so you can get paid after hosting a booking."/>),
    buttonText: (<FormattedMessage id="hosting.bank_status_data.account_needed_button_text" defaultMessage="Add Account"/>),
    onClickAction: () => { location.href = '/account/bank'; },
    alertState: true
  },
  account_added: {
    icon: 'bank',
    header: bankName,
    body: acctString,
    buttonText: (<FormattedMessage id="hosting.bank_status_data.update_button_text" defaultMessage="Update"/>),
    onClickAction: () => { location.href = '/account/bank'; }
  },
  update_account: {
    icon: 'bank-orange',
    header: (<FormattedMessage id="hosting.bank_status_data.update_account_header" defaultMessage="Update your bank account"/>),
    body: (<FormattedMessage id="hosting.bank_status_data.update_account_body" defaultMessage="There was an issue sending a payout to your bank account. Please update your account or use a different one."/>),
    buttonText: (<FormattedMessage id="hosting.bank_status_data.update_button_text" defaultMessage="Update"/>),
    onClickAction: () => { location.href = '/account/bank'; },
    alertState: true
  },
  payouts_error: {
    icon: 'bank-orange',
    header: (<FormattedMessage id="hosting.bank_status_data.payouts_error_header" defaultMessage="Payout Failed"/>),
    body: (<FormattedMessage id="hosting.bank_status_data.payouts_error_body" defaultMessage="Please make sure your bank account information is up to date."/>),
    buttonText: (<FormattedMessage id="hosting.bank_status_data.update_button_text" defaultMessage="Update"/>),
    onClickAction: () => { location.href = '/account/bank'; },
    alertState: true
  }
});
